import React from "react";
class MapZionNationalPark extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-zion-national-park" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Springdale,+UT&daddr=Zion+Canyon+Visitor+Center,+UT+to:Emerald+Pools+Trail,+Zion,+UT+to:Angels+Landing+Trailhead,+Zion,+UT+to:The+Narrows+Trailhead,+Zion,+UT+to:Canyon+Overlook+Trail,+Zion,+UT+to:Kolob+Canyons+Visitor+Center,+UT&output=embed"
            width="100%"
            height="420"
            title="Zion National Park route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapZionNationalPark;
